import {createFileRoute} from '@tanstack/react-router';
import {InvoiceAccountTransactionsPage} from '../../../../../../features/one-time-credit/pages/InvoiceAccountTransactionsPage/InvoiceAccountTransactionsPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/one-time-credit/$accountId/transactions',
)({
  component: InvoiceAccountTransactionsPage,
  staticData: {crumbKey: 'navigation.transactions'},
});
